import React, { useEffect, useState } from 'react';
import SearchIcon from '@material-ui/icons/Search';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  FormControl,
  InputLabel,
  Select,
  TextField,
  Typography,
  makeStyles,
  Button,
  Chip
} from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { Container, IconButton, InputBase, Paper, InputAdornment } from '@material-ui/core';
import { Header, DocumentUnavailable } from '../components/common';
import ResultSet from '../components/Search/ResultSet';
import useSearch from './useSearch';
import { ExpandMore } from '@material-ui/icons';
import { get } from '../utils/network';
import { handleLogout, deleteCookie } from '../utils/utils';
import { useHistory, useLocation } from 'react-router-dom';
import { DocumentTypesContext } from '../components/Search/DocumentTypesContext'
import posthog from 'posthog-js';

const useStyles = makeStyles(theme => ({
  root: {
    padding: 0,
    display: 'flex',
    flexDirection: 'row',
  },
  input: {
    flex: 12,
  },
  iconButton: {
    padding: 10,
  },

  cardcontent: {
    padding: 0,
    '&:last-child': {
      paddingBottom: 0,
    },
  },
}));

const Search = () => {
  const classes = useStyles();
  const { loading, result, userHasSearched, notAllowed, search, reset } = useSearch();
  const [documentTypesInfo, SetDocumentTypesInfo] = useState([{code: 'ANY', documentType: 'ANY', name: 'Any', description: 'Todos'}]);
  const [selectedType, SetSelectedType] = useState({
    doctype: 'ANY',
    query: '',
    advancedFilters: {}
  });
  const [appliedFilters, SetAppliedFilters] = useState({});
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const history = useHistory();
  const location = useLocation();

  useEffect(() => {

    // TODO: Mover la logica al hook
    const queryParams = new URLSearchParams(location.search);
    // TODO: Evitar que pise el estado inicial si esta vacia
    const doctype = queryParams.get('doctype') || 'ANY';
    const query = queryParams.get('query') || '*';
    const advancedFilters = {}
    for (const entry of queryParams.entries()) {
      if(entry[0] !== 'doctype' && entry[0] !== 'query' && entry[0] !== 'advancedFilters'){
        advancedFilters[entry[0]] = entry[1]
      }
      
    }
    // TODO: Mejorar logica para iniciar la busqueda
    if(queryParams.size > 0){
      SetSelectedType({doctype, query, advancedFilters})
      SetAppliedFilters(advancedFilters)
      // if(doctype !== 'ANY' && query !== '*'){
        search({doctype, query, advancedFilters, limit: rowsPerPage })
      // }
    } else {
      SetSelectedType({doctype: 'ANY', query: '', advancedFilters: {}})
      SetAppliedFilters({})
      reset();
    }

    get('documents/search/types')
      .then(response => {
        if (response.status === 401) {
          deleteCookie('isLogged');
          window.location.href = '/#/logout'
        }
        return response.json()
      })
      .then(result => {
        SetDocumentTypesInfo([{code: 'ANY', documentType: 'ANY', name: 'Any', description: 'Todos'}, ...result.message.data]);
      })
      .catch(error => console.log('error', error));
    }, [location.search, location.key]);

  const handleChange = event => {
    const name = event.target.name;
    if(event.target.value == 'ANY'){
      SetSelectedType({
        ...selectedType,
        [name]: event.target.value,
        advancedFilters: undefined,
      })
    } else {

      SetSelectedType({
        ...selectedType,
        [name]: event.target.value,
      });
    }
  };

  const handleChangeDoctype = (event, value) => {
    if(value) {
      SetSelectedType({
        ...selectedType,
        query: '',
        doctype: value.documentType,
      });
    }
  };
  
  const handleAdvancedSearchChange = event => {
    const name = event.target.name;
    SetSelectedType({
      ...selectedType,
      advancedFilters: {
        ...selectedType.advancedFilters,
        [name]: event.target.value
      }
    });
  }

  const handleSearch = e => {
    e.preventDefault();
    /*let searchParams = {...selectedType}
    delete searchParams.advancedFilters
    Object.keys(selectedType.advancedFilters).forEach(key => {
      searchParams[key] = key
    })*/
    let searchParams = {
      doctype: selectedType.doctype,
      query: selectedType.query,
    }

    SetAppliedFilters(selectedType.advancedFilters)

    if(selectedType.advancedFilters){
      Object.keys(selectedType.advancedFilters).forEach(key => {
        if (selectedType.doctype !== 'ANY' && Object.hasOwn(selectedDocTypeSchema.properties, key) && selectedType.advancedFilters[key]) {  
          searchParams[key] = selectedType.advancedFilters[key]
        }
      })
    }
    
    const queryString = new URLSearchParams(searchParams).toString();
    
    posthog.capture('search_performed', {
      trigger: 'search_button',
      doctype: searchParams.doctype,
      query: searchParams.query,
    });

    history.push(`/search?${queryString}`);

    search({...searchParams, limit: rowsPerPage});
  };
  const selectedDocumentTypeInfo = documentTypesInfo.filter(doc => doc.documentType == selectedType.doctype)[0]; // Should be only 1 item in this array
  //const filtersSchemas = filters[0]?.schema ? JSON.parse(filters[0].schema) : {};
  // const filterLabels = selectedDocumentTypeInfo?.labels ? selectedDocumentTypeInfo.labels : [];
  const selectedDocTypeSchema = selectedDocumentTypeInfo?.schema ? JSON.parse(selectedDocumentTypeInfo?.schema) : {}

  const handleDeleteChip = (chipToDelete) => () => {
    delete appliedFilters[chipToDelete]

    SetSelectedType({
      ...selectedType,
      advancedFilters: {
        ...selectedType.advancedFilters,
        [chipToDelete]: ''
      }
    });

    let searchParams = {
      doctype: selectedType.doctype,
      query: selectedType.query,
    }
    
    if(selectedType.advancedFilters){
      Object.keys(selectedType.advancedFilters).forEach(key => {
        if (selectedType.doctype !== 'ANY' && Object.hasOwn(selectedDocTypeSchema.properties, key) && selectedType.advancedFilters[key]) {  
          searchParams[key] = selectedType.advancedFilters[key]
        }
      })
    }
    delete searchParams[chipToDelete]
    
    const queryString = new URLSearchParams(searchParams).toString();
    history.push(`/search?${queryString}`);
    
    posthog.capture('search_performed', {
      trigger: 'delete_filter_chip',
      doctype: searchParams.doctype,
      query: searchParams.query,
    });

    search({...searchParams, limit: rowsPerPage});
  };

  if (notAllowed) {
    return <DocumentUnavailable />;
  }

  return (
    <DocumentTypesContext.Provider value={documentTypesInfo}>
    <div>
      <Header 
        title="Buscador de documentos"
        logout={() => handleLogout(history)}
      />
      <Container style={{maxWidth: '70rem'}}>
        <div
          style={{
            marginTop: '5rem',
            textAlign: 'center',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-around',
            alignItems: 'center',
            marginTop: userHasSearched ? '2.5rem' : '25vh',
            transition: 'margin 0.2s ease-in-out',
            paddingBottom: selectedType.doctype === 'ANY' ? '1rem' : ''
          }}
          className="App"
        >
          <FormControl
            style={{
              minWidth: '15rem',
              // display: 'flex',
              // flexDirection: 'row'
              width: '100%',
              display: 'grid',
              gridTemplateColumns: '1fr 4rem',
              gap: '1rem',
            }}
          >     
            <Paper
              variant="outlined"
              style={{ 
                borderRadius: '0.5rem', 
                padding: '0 1rem 0 1rem',
                display: 'grid',
                gridTemplateColumns: '1fr 2rem 2fr',
                border: '1px solid #25265d',
              }}
              className={classes.root}
              component="form"
            > 
              <Autocomplete
                id="doctype-selector"
                options={documentTypesInfo}
                value={{
                  description: documentTypesInfo.filter(doc => doc.documentType == selectedType.doctype)[0]?.description,
                  documentType: documentTypesInfo.filter(doc => doc.documentType == selectedType.doctype)[0]?.documentType
                }}
                getOptionLabel={(option) => `${option.description}`}
                onChange={(event, value) => {
                  handleChangeDoctype(event, value)
                }}
                label="Tipo de documento"
                renderInput={(params) => 
                  <TextField 
                    {...params} 
                    label="Tipo de documento" 
                    variant="standard" 
                    InputProps={{...params.InputProps, disableUnderline: true}} 
                  />}
                style={{
                  padding: '6px',
                  minWidth: '12rem'
                }}
              />
              <hr style={{color: '#efefef'}} />
              <InputBase
                style={{ width: '100%' }}
                placeholder="Ingrese su consulta"
                inputProps={{ 'aria-label': 'Search objects' }}
                value={selectedType.query}
                endAdornment={selectedType.query === '*' && <InputAdornment position="end">Buscando todos los documentos</InputAdornment>}
                onChange={handleChange}
                name="query"
                autoFocus={true}
              />
            </Paper>
            <Button 
              type="submit" 
              aria-label="search" 
              onClick={handleSearch} 
              variant="contained"
              color="primary"
              style={{ borderRadius: '4rem', width: '4rem', height: '4rem', backgroundColor: '#F05033' }}
            >
              <SearchIcon fontSize='large'/>
            </Button>
          </FormControl>
        </div>
        { selectedType.doctype !== 'ANY' &&     
          <div id={'advanced-search'}>
          <Accordion
            style={{
              marginTop: '1rem',
              marginBottom: '1rem',
              minWidth: '40rem',
              borderRadius: '0.5rem',
            }}
          >
            <AccordionSummary
              expandIcon={<ExpandMore />}
              aria-controls="panel1a-content"
              id="panel1a-header"
            >
              <div style={{ flexDirection: 'column' }}>
                <Typography>Filtros</Typography>
                <div>
                {appliedFilters && selectedDocTypeSchema.properties && Object.keys(appliedFilters).map((key, index)=>{
                  if(selectedType.advancedFilters[key] == '' || selectedType.doctype == 'ANY' || !Object.hasOwn(selectedDocTypeSchema.properties, key)) {
                    delete selectedType.advancedFilters[key]
                    delete appliedFilters[key]
                    return <></>
                  } 
                  return (<Chip 
                      variant="outlined" 
                      size="small" 
                      onDelete={handleDeleteChip(key)} 
                      style={{marginRight: '0.5rem'}}
                      label={`${selectedDocTypeSchema.properties[key].label}: ${selectedType.advancedFilters[key]}`} key={index}
                    />)
                })}
                </div>
              </div>

            </AccordionSummary>
            <AccordionDetails>
              <FormControl 
                style={{
                  width: '100%',
                  display: 'flex',
                  alignItems: 'flex-end'
                }}
              >
                <div
                  style={{
                    display: 'grid',
                    width: '100%',
                    gridTemplateColumns: ' 1fr 1fr 1fr',
                    textAlign: 'center',
                    gap: '0.5rem',
                  }}
                >
                  {/* <DatePicker style={{ padding: 0, margin: 0 }} label={'Fecha desde'} />
                  <DatePicker label={'Fecha hasta'} /> */}
                  {selectedDocTypeSchema?.properties && Object.keys(selectedDocTypeSchema.properties).map((propertyKey) => (
                    <TextField
                      id="outlined-basic"
                      variant="outlined"
                      key={propertyKey}
                      label={selectedDocTypeSchema.properties[propertyKey].label}
                      onChange={handleAdvancedSearchChange}
                      value={selectedType.advancedFilters[propertyKey]}
                      name={propertyKey}
                    />
                  ))}
                </div>
                {selectedType.doctype !== "ANY" &&
                  <Button
                  color="primary"
                  variant="contained"
                  onClick={handleSearch}
                  style={{ marginTop: '1rem', maxWidth: '10rem' }}
                  >
                    Aplicar filtros
                  </Button>
                }
              </FormControl>
            </AccordionDetails>
          </Accordion>

          </div>
        }
        <div
          style={{
            transition: 'opacity 0.4s ease-in-out',
            opacity: userHasSearched ? '100%' : '0%',
          }}
        >
          {userHasSearched && result && (
            <div>
              <ResultSet
                loading={loading}
                results={result}
                query={selectedType}
                docTypes={documentTypesInfo}
                rowsPerPage={rowsPerPage}
                onRowsPerPageChange={setRowsPerPage}
              />
            </div>
          )}
        </div>
      </Container>
    </div>
    </DocumentTypesContext.Provider>
  );
};

export default Search;
